import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  HostListener,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { DataResult, DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { Subscription } from "rxjs";
import { subHeadings } from "src/app/properties/map_sub_heading";
import { SyncfusionService } from "src/app/services/syncfusion.service";
import { AppSettingService } from 'src/app/services/app-setting.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReusableFilterMoleculeComponent } from "../../molecules/reusable-filter-molecule/reusable-filter-molecule.component";
import { ClickStreamAnalyticsService, EventType } from "src/app/services/clickstream-analytics-service";
import { FilterBayService } from "src/app/services/filter-bay.service";
import { SyncfusionGridComponent } from "../../molecules/syncfusion-grid/syncfusion-grid.component";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { filter } from "rxjs/operators";



@Component({
  selector: "app-sync-fusion-organisms",
  templateUrl: "./sync-fusion-organisms.component.html",
  styleUrls: ["./sync-fusion-organisms.component.scss"],
})
export class SyncFusionOrganismsComponent implements OnDestroy {
  reportName: any;
  reportNameWithSpace: any;
  tagline: any;
  data: any;
  dynamic_headers: any[];
  today = new Date();
  count: any;
  tableDataFetched: boolean = false;
  subHeadings = subHeadings;
  private queryParamsSubscription: Subscription;
  visiblePOPUP: boolean;
  fieldData: any;
  headerData: any;
  generatedDate: any
  showFilter: boolean = false;
  filterData: any;
  showFiltersPopup: boolean = false;
  reportLabelText: string;
  appliedFilters: any = {};
  decisionAttribute: any;
  settings: any;
  range: FormGroup;
  dateFilterRequired: boolean = false;
  dateFilterAttribute: string = '';
  selectedDateRange: any = null;
  allGridFilters: any[] = [];
  freezeColumns: number | undefined;
  sortFilterOptions: any;
  showSearchField: boolean = false;
  showSortField: boolean = false;
  searchText: string = '';
  sortByOption: string = '';
  sortByAsc: boolean = true;
  sortData: any = { sortColumn: '', sortDesc: false };
  gridListPayload: {
    pageSize: any,
    pageNumber: any,
    gridFilters: any,
    searchText: any,
    sortData: {
      "sortColumn": any,
      "sortDesc": any
    },
  }
  totalRecordCount: any;
  currentPage: any;
  @ViewChild("childFilter", { static: false }) public childComponent !: ReusableFilterMoleculeComponent;
  @ViewChild('gridRef') gridRef!: SyncfusionGridComponent;
  constructor(
    private route: ActivatedRoute,
    private syncfusion: SyncfusionService,
    private cdr: ChangeDetectorRef,
    private settingsService: AppSettingService,
    private snack: MatSnackBar,
    private clickStream: ClickStreamAnalyticsService,
    private filterbayservice: FilterBayService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.settings = this.settingsService.getSettings();
    this.range = this.fb.group({
      start: new FormControl(),
      end: new FormControl(),
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.filterbayservice.setReportFilters(this.reportName, {}, {}); // Reset filters
      }
    });
    this.queryParamsSubscription = this.route.queryParams.subscribe(
      (params) => {
        this.data = [];
        this.dynamic_headers = [];
        this.allGridFilters = [];
        this.appliedFilters = {};
        this.filterbayservice.setReportFilters(params.reportName, {}, {});
        if (params && params.reportName) {
          this.range.reset();
          this.selectedDateRange = null;
          this.reportLabelText = '';
          this.showFilter = false;
          this.reportName = params.reportName;
          this.freezeColumns = this.reportName === 'fulfilment_plan_report' ? 4 : undefined;
          this.reportNameWithSpace = "Just a moment, we're compiling your insights...";
          this.tableDataFetched = false;
          this.tagline = this.subHeadings[this.reportNameWithSpace];
          this.dateFilterRequired = false;
          // Check settings if this report requires date filter
          if (this.requiresDateFilter(this.reportName)) {
            this.dateFilterRequired = true;
            this.dateFilterAttribute = this.settings.reports[this.reportName].date_filter;
            return;
          }
          this.gridListPayload = {
            pageSize: 50,
            pageNumber: 1,
            gridFilters: [],
            searchText: '',
            sortData: {
              "sortColumn": "",
              "sortDesc": false
            },
          };
          this.loadReport(this.gridListPayload);
        }
      }
    );
  }
  onDateRangeSelected() {
    this.selectedDateRange = null;
    const start = this.range.get('start')?.value;
    const end = this.range.get('end')?.value;
    if (!start || !end) {
      this.showSnackbar("Please select both start and end dates.");
      return;
    }
    const formattedStart = new Date(start).toLocaleDateString('en-CA') + 'T00:00:00';
    const formattedEnd = new Date(end).toLocaleDateString('en-CA') + 'T00:00:00';
    const filters = [
      {
        column: this.dateFilterAttribute,
        condition: "GREATER_THAN_EQUAL",
        value: formattedStart,
        type: "DATE"
      },
      {
        column: this.dateFilterAttribute,
        condition: "LESS_THAN_EQUAL",
        value: formattedEnd,
        type: "DATE"
      }
    ];
    this.allGridFilters = this.allGridFilters.filter(f => f.column !== this.dateFilterAttribute);
    this.allGridFilters.push(...filters);
    this.tableDataFetched = false;
    this.gridListPayload = {
            pageSize: 200,
            pageNumber: 1,
            gridFilters: this.allGridFilters,
            searchText: '',
            sortData: {
              "sortColumn": "",
              "sortDesc": false
            },
          }
    this.loadReport(this.gridListPayload);
    this.selectedDateRange = { start, end }; // this enables the grid
  }

  roundSmart(value: number): number {
    const rounded = Number(value.toFixed(2));
    return rounded % 1 === 0 ? Math.round(rounded) : rounded;
  }
  loadReport(payload?: any) {
    this.tableDataFetched = false;
    if (this.settingsService.isRemoteGridMode()) {
      this.syncfusion.getPaginatedSyncfusionData(this.reportName, payload).subscribe((res) => {

        if (res) {
          this.getFilters();
          if (res.displayName && res.displayName.trim() !== '') {
            this.reportNameWithSpace = res.displayName;
          }
          else {
            this.reportNameWithSpace = this.reportName.replace(/_/g, " ");
          }
          if (res.displayTagLine) {
            this.tagline = res.displayTagLine;
          } else {
            this.tagline = this.subHeadings[this.reportNameWithSpace];
          }
          this.dynamic_headers = JSON.parse(res.headerContent);
          this.showSearchField = this.dynamic_headers.some(header => header.isSearchable);
          this.showSortField = this.dynamic_headers.some(header => header.isSortable);
          this.sortFilterOptions = this.dynamic_headers
            .filter(header => header.isSortable)
            .map(header => ({
              label: header.headerText,
              value: header.field
            }));
          const summaryFields = this.dynamic_headers.filter(h => h.summarize).map(h => h.field);
          if (summaryFields.length > 0) {
            this.freezeColumns = 1;
            const labelKey = this.dynamic_headers[0].field;
            const totalRow: any = {};
            if (labelKey) totalRow[labelKey] = 'Total';
            for (const field of summaryFields) {
              let sum = 0;
              for (const row of res.items) {
                sum += Number(row[field]) || 0;
              }
              totalRow[field] = this.roundSmart(sum);
            }
            res.items.push(totalRow);
          }
          this.data = (<DataResult>{
            result: res.items,
            count: res.pageData ? res.pageData.totalRecords : res.count
          });
          const pageData = res["pageData"];
          this.gridListPayload.pageSize = pageData["pageSize"];
          this.gridListPayload.searchText = pageData["searchText"];
          this.gridListPayload.sortData = pageData["sortData"];
          this.gridListPayload.gridFilters = pageData["gridFilters"]
          this.currentPage = pageData["pageNumber"] - 1;
          this.totalRecordCount = pageData["totalRecords"];
          this.appliedFilters = this.filterbayservice.getReportFilters(this.reportName)["displayFilters"];
          this.generatedDate = this.data?.result[0]?.recordDate;
          this.syncfusion.setExportData(res);
          this.reportLabelText = res.baseReportText;
          this.count = res.count;
          setTimeout(() => {
            this.tableDataFetched = true;
            if (this.gridRef?.grid) {
              this.gridRef.grid.clearFiltering(); // clear filters
              this.gridRef.grid.clearSorting();   // clear sorting
            }
            this.cdr.detectChanges();
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        console.error(error);
        this.showSnackbar("Error while fetching report");
      })
    } else {
      this.syncfusion.getSyncfusionData(this.reportName).then((res) => {
        if (res) {
          if (res.displayName && res.displayName.trim() !== '') {
            this.reportNameWithSpace = res.displayName;
          }
          else {
            this.reportNameWithSpace = this.reportName.replace(/_/g, " ");
          }
          this.dynamic_headers = JSON.parse(res.headerContent);
          this.showSearchField = this.dynamic_headers.some(header => header.isSearchable);
          this.showSortField = this.dynamic_headers.some(header => header.isSortable);
          this.sortFilterOptions = this.dynamic_headers
            .filter(header => header.isSortable)
            .map(header => ({
              label: header.headerText,
              value: header.field
            }));
          const summaryFields = this.dynamic_headers.filter(h => h.summarize).map(h => h.field);
          if (summaryFields.length > 0) {
            this.freezeColumns = 1;
            const labelKey = this.dynamic_headers[0].field;
            const totalRow: any = {};
            if (labelKey) totalRow[labelKey] = 'Total';
            for (const field of summaryFields) {
              let sum = 0;
              for (const row of res.items) {
                sum += Number(row[field]) || 0;
              }
              totalRow[field] = this.roundSmart(sum);
            }
            res.items.push(totalRow);
          }
          this.data = res.items;
          const pageData = res["pageData"];
          this.gridListPayload.pageSize = pageData["pageSize"];
          this.gridListPayload.searchText = pageData["searchText"];
          this.gridListPayload.sortData = pageData["sortData"];
          this.gridListPayload.gridFilters = pageData["gridFilters"]
          this.currentPage = pageData["pageNumber"] - 1;
          this.totalRecordCount = pageData["totalRecords"];
          this.generatedDate = this.data[0]?.recordDate;
          this.count = res.count;
          setTimeout(() => {
            this.tableDataFetched = true;
            if (this.gridRef?.grid) {
              this.gridRef.grid.clearFiltering(); // clear filters
              this.gridRef.grid.clearSorting();   // clear sorting
            }
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        console.error(error);
        this.showSnackbar("Error while fetching report");
      });
    }
  }
  handleHeaderPrintClick() {
    if (this.gridRef) {
      this.gridRef.triggerExcelExportFromOutside();
    }
  }
  requiresDateFilter(reportName: string): boolean {
    return (
      this.settings?.reports &&
      this.settings.reports[reportName] &&
      this.settings.reports[reportName].date_filter
    );
  }


  navigateGrid(state: DataStateChangeEventArgs) {
    if ((state as any).action?.requestType === 'filterchoicerequest' || (state as any).action?.requestType === 'stringfilterrequest' ||
      (state as any).action?.requestType === 'filtersearchbegin' || (state as any).action?.requestType === 'filterbeforeopen') {
      return;
    }
    const pageData = this.syncfusion.convertGridStateToPageData(state);
    // Merge global filters like date
    pageData.gridFilters = this.gridListPayload.gridFilters;
    pageData.sortData = this.gridListPayload.sortData;
    pageData.searchText = this.gridListPayload.searchText

    const payload = { ...pageData };
    this.syncfusion.getPaginatedSyncfusionData(this.reportName, payload).subscribe((res) => {
      if (res) {
        const headers = JSON.parse(res.headerContent);
        const summaryFields = headers.filter(h => h.summarize).map(h => h.field);
        if (summaryFields.length > 0) {
          this.freezeColumns = 1;
          const labelKey = headers[0].field;
          const totalRow: any = {};
          if (labelKey) totalRow[labelKey] = 'Total';
          for (const field of summaryFields) {
            let sum = 0;
            for (const row of res.items) {
              sum += Number(row[field]) || 0;
            }
            totalRow[field] = this.roundSmart(sum);
          }
          res.items.push(totalRow);
        }
        this.data = (<DataResult>{
          result: res.items,
          count: res.pageData ? res.pageData.totalRecords : res.count
        });
        this.reportLabelText = res.baseReportText;
        this.syncfusion.setExportData(res);
        setTimeout(() => {
          this.tableDataFetched = true;
        });
      }
    }, (error) => {
      this.tableDataFetched = true;
      console.error(error);
      this.showSnackbar("Error while fetching report");
    })
  }

  handlePOPUP(event) {
    this.fieldData = event.fieldData;
    this.headerData = event.header;
    this.visiblePOPUP = true;
  }
  ngOnDestroy(): void {
    this.filterbayservice.setReportFilters(this.reportName, {}, {});
    this.appliedFilters = {};
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    this.selectedDateRange = null;
    this.allGridFilters = [];
    this.gridListPayload = {
      pageSize: 50,
      pageNumber: 1,
      gridFilters: [],
      searchText: '',
      sortData: {
        "sortColumn": "",
        "sortDesc": false
      },
    };
  }
  showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  getFilters() {
    this.syncfusion.getAvailableFilters(this.reportName).subscribe((res: any) => {
      this.filterData = res?.filterDataList;
      this.filterData = this.filterData.sort((a, b) => a.position - b.position);
      this.showFilter = this.filterData.length > 0;
      this.clickStream.publishGAEvent(EventType.FILTER, {
        section: this.reportName
      });
    }, (error) => {
      this.showSnackbar('Error while fetching filters.Please try again later');
    })
  }
  toggleFilterOverlay() {
    this.showFiltersPopup = !this.showFiltersPopup;
    if (this.showFiltersPopup) {
      this.childComponent.createOverlay();
    }
  }
  selectedFilters(event) {
    this.appliedFilters = JSON.parse(JSON.stringify(event));
  }
  handleFilterOutput(data: any) {
    this.allGridFilters = this.allGridFilters.filter(f => f.column === this.dateFilterAttribute);
    this.allGridFilters.push(...data);
    // const payload = { "gridFilters": this.allGridFilters, "pageSize": 200, "pageNumber": 1 };
    this.gridListPayload.gridFilters = this.allGridFilters;
    this.reportNameWithSpace = "Just a moment, we're compiling your insights...";
    this.loadReport(this.gridListPayload)
  }
  searchWithText() {
    this.gridListPayload.searchText = this.searchText
    this.clickStream.publishGAEvent(EventType.SEARCH, {
      value: this.searchText,
      section: this.reportName
    });

    this.loadReport(this.gridListPayload);
  }
  onInputChange(event: any) {
    if (!this.searchText || this.searchText.trim().length === 0) {
      this.gridListPayload.searchText = "";
      this.loadReport(this.gridListPayload);
    }
  }
  handleValueChange(event) {
    this.sortByOption = event;
    this.gridListPayload.sortData.sortColumn = event;
    this.loadReport(this.gridListPayload);
  }
  sortByAscOrDes() {
    this.sortByAsc = !this.sortByAsc;
    this.gridListPayload.sortData.sortDesc = this.sortByAsc;
    this.clickStream.publishGAEvent(EventType.SORT, {
      value: this.sortByOption,
      section: this.reportName
    });
    this.loadReport(this.gridListPayload);
  }
}
